module.exports = __webpack_public_path__ + "img/corona-black.3fb0c395.jpg";